import { Component, OnInit } from '@angular/core';
import { CategoriaService } from '../../../services/categoria/categoria.service';
import { UsuarioService } from '../../../services/usuario/usuario.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {

  categoriasPadres: any[] = [];
  deFantasia: any[] = [];
  emailSuscriptor: string;
  isLoading = false;
  cFantasiaEspecialesParams: any;

  constructor(
    private _categoriaService: CategoriaService,
    private _usuarioService: UsuarioService,
    private _toastr: ToastsManager,
  ) {
    this.cFantasiaEspecialesParams = {'per_page': 6, 'visibility': ['HOME']};
  }

  ngOnInit() {

    this._categoriaService.getPadres()
      .subscribe( data => {
        this.categoriasPadres = data;
      });

    this._categoriaService.getDeFantasia(this.cFantasiaEspecialesParams)
      .subscribe( data => {
        this.deFantasia = data;
      });
  }

  onSubmit() {
    this.isLoading = true;
    this._usuarioService.suscribir(this.emailSuscriptor)
      .subscribe(
        resp => {
          this.isLoading = false;
          delete this.emailSuscriptor;
          this._toastr.success('Suscripción realizada con éxito!');
        },
        error => {
          this.isLoading = false;
          this._toastr.error('En estos momentos no podemos atender su solicitud.');
        }
      );

  }
}



// WEBPACK FOOTER //
// /app/src/app/components/structure/footer/footer.component.ts